import React, { useState } from "react"
import type { TechnicianData } from "../../../types"
import { COUNCILS, DEFAULT_COUNCIL, UFS } from "../constants"
import { Field, Input, Select, StepNav } from "../ui"

interface Props {
  archetypeKey: string
  data: TechnicianData
  onChange: (data: TechnicianData) => void
  onBack: () => void
  onContinue: () => void
}

export default function TechnicianStep({ archetypeKey, data, onChange, onBack, onContinue }: Props) {
  const [touched, setTouched] = useState(false)

  const set = (field: keyof TechnicianData) => (value: string) =>
    onChange({ ...data, [field]: value })

  const numberDigits = data.council_number.replace(/\D/g, "")
  const numberValid = numberDigits.length >= 3 && numberDigits.length <= 6
  const valid = data.name.trim() !== "" && data.council !== "" && numberValid && data.uf !== ""

  function continueStep() {
    setTouched(true)
    if (valid) onContinue()
  }

  const defaultCouncil = DEFAULT_COUNCIL[archetypeKey]

  return (
    <section>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold text-ink">
        Quem assina o plano?
      </h1>
      <p className="mt-3 text-gray-600">
        O Responsável Técnico (RT) assina o PGRSS. No seu caso, normalmente é você
        {defaultCouncil && <> — com o registro do <span className="font-semibold">{defaultCouncil}</span></>}.
      </p>

      <div className="mt-8 space-y-5">
        <Field label="Nome completo do RT" required error={touched && data.name.trim() === "" ? "Obrigatório" : null}>
          <Input value={data.name} onChange={set("name")} placeholder="Ex.: Ana Souza" autoFocus />
        </Field>

        <div className="grid grid-cols-[8rem_1fr_7rem] gap-4">
          <Field label="Conselho" required>
            <Select value={data.council} onChange={set("council")} options={[...COUNCILS]} placeholder="—" />
          </Field>
          <Field
            label="Nº de registro"
            required
            error={touched && !numberValid ? "Número de 3 a 6 dígitos" : null}
          >
            <Input value={data.council_number} onChange={set("council_number")} placeholder="12345" inputMode="numeric" />
          </Field>
          <Field label="UF" required error={touched && data.uf === "" ? "Obrigatório" : null}>
            <Select value={data.uf} onChange={set("uf")} options={[...UFS]} placeholder="UF" />
          </Field>
        </div>

        <p className="rounded-xl bg-brand-50 border border-brand-100 px-4 py-3 text-sm text-brand-900">
          Validamos o formato do registro pra garantir que o documento saia assinável —
          registro inválido é o motivo nº 1 de reprovação na vigilância.
        </p>
      </div>

      <StepNav onBack={onBack} onContinue={continueStep} continueDisabled={touched && !valid} />
    </section>
  )
}
